import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Permission } from '../common/enums';
import { AuthGuard } from '../core/authentication/auth.guard';
import { PermissionGuard } from '../core/authentication/permission.guard';
import { AdminLayoutComponent } from './admin-layout/admin-layout.component';
import { ImportFromExternalSystemComponent } from './import-from-external-system/import-from-external-system.component';

const routes: Routes = [
    {
        path: 'admin',
        component: AdminLayoutComponent,
        canActivate: [AuthGuard, PermissionGuard],
        data: {
            permissions: [Permission.ImportFromExternalSystem],
        },
        children: [
            { path: '', redirectTo: 'importfromexternalsystem', pathMatch: 'full' },
            { path: 'importfromexternalsystem', component: ImportFromExternalSystemComponent },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AdminRoutingModule { }
